import React from 'react';
import { useSelector } from 'react-redux';

import { messageDialogConfig, messageDialogSlice } from '../../../Redux/MessageDialogSlice';
import MessageDialog from './MessageDialog';
import globalStore from '../../../Redux/initStore';

/**
 * Component that shows a configurable information dialog.
 */
export default () => {
    const dialogConfig = useSelector(messageDialogConfig);

    if (dialogConfig === null) {
        return <></>;
    }

    const handleClose = () => {
        globalStore.dispatch(messageDialogSlice.actions.update(null));
    };

    return (
        <MessageDialog
            type={dialogConfig.type}
            title={dialogConfig.title}
            description={dialogConfig.message}
            closeFn={handleClose}
        />
    );
};
